import React from "react";
import { Typography } from "@mui/material";

export default function AppBuildFooter({ sx = {} }) {
  const appEnvRaw = process.env.REACT_APP_ENV;
  const appVersionRaw = process.env.REACT_APP_VERSION;
  const appEnv = (appEnvRaw ?? "").trim().toLowerCase().replace(/[^a-z0-9_-]/g, "");
  const appVersion = (appVersionRaw ?? "").trim().replace(/[^0-9a-zA-Z._-]/g, "");
  const showEnv = appEnv.length > 0 && appEnv !== "production" && appEnv !== "prod";
  const showVersion = appVersion.length > 0;

  return (
    <Typography
      variant="caption"
      sx={{
        display: "block",
        textAlign: "center",
        opacity: 0.7,
        ...sx,
      }}
    >
      {`Inssa${showEnv ? ` ${appEnv}` : ""}${showVersion ? ` v${appVersion}` : ""}`}
    </Typography>
  );
}
